import * as React from 'react';
import { Form, formValueSelector, reduxForm } from 'redux-form';
import { flow } from 'lodash';
import {Button, Row} from 'react-bootstrap';
import {
    IChannel,
    IPolicyApplication,
} from '../../../../data/api/models';
import FaChevronRight from 'react-icons/fa/chevron-right';
import {connect} from 'react-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {bindActionCreators} from 'redux';
import {IStore} from '../../../../redux/IStore';
import DeclarationConsent from '../../components/DeclarationConsent';

interface IPersonalDetailsProps {
    onBack: () => void;
    handleSubmit: () => void;
    product: any;
    channel: IChannel;
    isMobileView: boolean;
}

class Declaration extends React.Component<IPersonalDetailsProps> {

    public render() {
        const { handleSubmit, onBack, product, channel, isMobileView } = this.props;

        return (
            <div>
                <Form onSubmit={handleSubmit} autoComplete="off">
                    <div className="steps-container">
                        <div className="section-title">
                            <h3>Declaration</h3>
                        </div>
                        <div className="section">
                            <Row>
                                <DeclarationConsent
                                    productTerms={product.metadata.product_terms}
                                    productDefinitions={product.metadata.definitions}
                                    channel={channel}
                                    isMobileView={isMobileView}
                                />
                            </Row>
                        </div>
                        <div className="btn-bar margin-top">
                            <Button
                                bsStyle="primary"
                                type="submit"
                                className="pull-right btn-remove-border">
                                Continue
                                <FaChevronRight/>
                            </Button>
                            <Button type="button" className="btn-back btn-remove-border" onClick={onBack}>
                                Back
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

let selector;
let previousValues;

export default flow([
    reduxForm({
        form: 'quote',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        onChange: (
            values: IPolicyApplication,
            dispatch,
            props: IPersonalDetailsProps,
        ) => {
            if (! previousValues) {
                previousValues = values;
                return;
            }

            previousValues = values;
        },
    }),
    (component) => {
        selector = formValueSelector('quote');

        return component;
    },
    connect(
        (state: IStore) => {

            return {
                auth: state.auth,
                channel: state.branding.channel,
            };
        },
        (dispatch) => ({
            actions: {
                quote: bindActionCreators({ ...quoteActions }, dispatch),
            },
        }),
    ),
])(Declaration);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Declaration/index.tsx